module.exports = "/_next/static/images/21f73bc1a842786c502c54abf2bf2bb5-mastercard-left-small.jpg";